import { useQuery,useMutation } from "@1f/react-sdk";
import { query_base_security_area } from "../query/baseTablesQueries";
import { createBaseSecurityAreaModel,createUserPermissionModel  } from "../helpers/modelHelpers"
import { query_user_permission_byUserCount, query_user_permission_byUser } from "../query/permissionQueries"
import {mutation_add_user_permission} from "../mutations/permessiMutations"

export const PermissionApi = () => {
    const apiBaseSecurityArea = useQuery(
        query_base_security_area,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiPermissionByUserCount = useQuery(
        query_user_permission_byUserCount,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiPermissionByUser = useQuery(
        query_user_permission_byUser,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAddUserPermission = useMutation(mutation_add_user_permission, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });

    const GetBaseSecurityAreas = async () => {
        try {
            let areaItems = [];
            let allBaseSecurityAreas = await apiBaseSecurityArea.fetch();
            if(allBaseSecurityAreas && allBaseSecurityAreas.data){
                allBaseSecurityAreas.data.data.base_security_area.map((item) =>
                    areaItems.push(createBaseSecurityAreaModel(item))
                );
            }
            return areaItems;
        } catch (error) {
            throw new Error("Errore durante il recupero delle aree di sicurezza base");
        }
    }
    const GetUserPermissionsCount = async (userId,aziendaId) => {
        try {
            let userPermsCount = await apiPermissionByUserCount.fetch({
                userId: userId,
                aziendaId: aziendaId,
            });
            if(userPermsCount && userPermsCount.data){
                return userPermsCount.data.data.user_permission_aggregate.aggregate.count;
            }
        } catch (error) {
            throw new Error (`Impossibile recuperare il numero di permessi per l'utente ${userId} sull'azienda ${aziendaId} : ${error.message}`)
        }
    }
    const GetUserPermissions = async (userId,aziendaId,allAreaItems) => {
        try {
            let userPermissions = []
            let userPermsResponse = await apiPermissionByUser.fetch({
                userId: userId,
                aziendaId: aziendaId,
            });
            if (userPermsResponse && userPermsResponse.data){
                userPermsResponse.data.data.user_permission.map((item) =>
                    userPermissions.push(createUserPermissionModel(item,allAreaItems))
                );
            }       
            return userPermissions;         
        } catch (error) {
            throw new Error(`Impossibile recuperare i permessi per l'utente ${userId} sull'azienda ${aziendaId} : ${error.message}`);
        }
    }
    const PostUserPermission = async (userId,aziendaId,area,canRead,canCreate,canUpdate,canDelete,allAreaItems) => {
        try {
            let addedPermissionResponse = await apiAddUserPermission.fetch({
                userId: userId,
                aziendaId: aziendaId,
                area: area,
                canRead: canRead,
                canCreate: canCreate,
                canUpdate: canUpdate,
                canDelete: canDelete,
            })
            if(addedPermissionResponse && addedPermissionResponse.data){
                return createUserPermissionModel(addedPermissionResponse.data.data.insert_user_permission_one, allAreaItems);
            }
        } catch (error) {
            throw new Error(`Impossibile aggiungere il permesso sull'area ${area} per l'utente ${userId} sull'azienda ${aziendaId} : ${error.message}`)
        }
    }

    return {
        GetBaseSecurityAreas,
        GetUserPermissionsCount,
        GetUserPermissions,
        PostUserPermission
    }
} 